import { createAction } from 'redux-actions';

import { WEBSOCKET_ONLINE, WEBSOCKET_OFFLINE } from './constants';

export const websocketOnline = createAction(WEBSOCKET_ONLINE);
export const websocketOffline = createAction(WEBSOCKET_OFFLINE);
